<script setup lang="ts">
import { computed } from 'vue'
import { useVaultStore } from '../../stores/vault'
import type { Person } from '../../data/demo'
import { icon } from '../../lib/icons'

const props = defineProps<{ personId: string }>()
const vault = useVaultStore()

const person = computed<Person | undefined>(() => vault.people.find(p => p.id === props.personId))
const rels = computed(() =>
  vault.relations
    .filter(l => l.a === props.personId || l.b === props.personId)
    .map(l => {
      const otherId = l.a === props.personId ? l.b : l.a
      return { other: vault.people.find(p => p.id === otherId), type: l.type, note: l.note }
    })
    .filter(r => r.other),
)
</script>

<template>
  <div v-if="person" class="pcard">
    <h3>
      <i class="cp-av" :style="{ '--c1': person.c1, '--c2': person.c2 }"></i>
      {{ person.name }}<small>{{ person.title }} · {{ person.rel }}</small>
    </h3>
    <div v-if="rels.length" class="rel">
      <span v-for="r in rels" :key="r.other!.id" :class="r.type">{{ r.other!.name }} · {{ r.note }}</span>
    </div>
    <p>{{ person.tip }}</p>
    <div class="chips">
      <span v-for="d in person.dos" :key="d" class="do"><span v-html="icon('check')"></span>{{ d }}</span>
      <span v-for="d in person.donts" :key="d" class="dont"><span v-html="icon('x')"></span>{{ d }}</span>
    </div>
  </div>
</template>
